/**
 * Celular brasileiro: a tela só lida com +55.
 *
 * O campo mostra o prefixo fixo e guarda apenas os dígitos nacionais (DDD +
 * número). Quem envia para a Auth0/BFF continua usando `normalizePhoneOrThrow`,
 * que devolve E.164.
 */

/** DDD + número, no máximo 11 dígitos. */
export function phoneDigits(value: string): string {
  return value.replace(/\D/g, '').slice(0, 11)
}

/** Máscara de exibição: (11) 99999-8888 — sem o +55, que é fixo na tela. */
export function formatPhoneBr(value: string): string {
  const d = phoneDigits(value)
  if (d.length <= 2) return d
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`
}

/** Celular válido no Brasil: 10 ou 11 dígitos nacionais. */
export function isValidPhoneBr(value: string): boolean {
  const length = phoneDigits(value).length
  return length >= 10 && length <= 11
}

/** Mesma máscara, aceitando valor colado com +55 (autofill, área de transferência). */
export function formatBrPhone(value: string): string {
  const d = value.replace(/\D/g, '')
  return formatPhoneBr(d.startsWith('55') && d.length >= 12 ? d.slice(2) : d)
}
